<template>
  <footer>
    <div class="app-wrapper typeface-small">
      <div>© MAPPREXPLORE S.L. Made with ❤️ in Barcelona</div>
      <div>
        <a
          href="https://wiki.mappr.com/s/b2563ced-0d51-4df8-adaf-a0465716f531"
          target="_blank"
          >Help & Guides</a
        >
        &nbsp;-&nbsp;
        <NuxtLinkLocale to="/info/copyright">Copyright Policy</NuxtLinkLocale>
        &nbsp;-&nbsp;
        <NuxtLinkLocale to="/info/creator-compensation"
          >Creator Compensation</NuxtLinkLocale
        >
        &nbsp;-&nbsp;
        <NuxtLinkLocale to="/info/creator-terms">Creator Terms</NuxtLinkLocale>
        &nbsp;-&nbsp;
        <NuxtLinkLocale to="/info/legal-notice">Legal Notice</NuxtLinkLocale>
        &nbsp;-&nbsp;
        <NuxtLinkLocale to="/info/privacy-policy"
          >Privacy Policy</NuxtLinkLocale
        >
        &nbsp;-&nbsp;
        <NuxtLinkLocale to="/info/cookie-policy">Cookie Policy</NuxtLinkLocale>
        &nbsp;-&nbsp;
        <a href="mailto:info@mappr.com"> info@mappr.com </a>
      </div>
      <div>
        <img src="/images/eu-finance.png" alt="" />
      </div>
    </div>
  </footer>
</template>

<style lang="postcss" scoped>
footer {
  background-color: var(--color-slate-100);
  padding: 1rem;
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    color: var(--color-slate-500);
    a {
      color: var(--color-slate-500);
      text-decoration: none;
    }

    > div {
      padding: 1rem;
      text-align: center;

      > img {
        width: 502px;
      }
    }
  }
}
</style>
